import { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import { logUsage } from 'owa-analytics';
import { AttachmentOpenAction, getAttachmentDefaultOpenAction } from 'owa-attachment-data';
import { AttachmentFullViewState, AttachmentMenuAction } from 'owa-attachment-full-data';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import getAttachmentFileType from 'owa-attachment-model-store/lib/utils/getAttachmentFileType';
import { lazyPreviewAttachment, PreviewContext } from 'owa-attachment-select-actions';
import { isFeatureEnabled } from 'owa-feature-flags';
import loc from 'owa-localize';
import { PreviewText } from 'owa-locstrings/lib/strings/previewtext.locstring.json';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import { isSxSDisplayedForAttachment } from 'owa-sxs-store';
import isMenuActionSupported from '../../utils/isMenuActionSupported';
import { ControlIcons } from 'owa-control-icons';

export default function previewContextMenuItemBuilder(
    attachment: AttachmentFullViewState,
    providerType: string,
    targetWindow: Window,
    sxsId: string,
    isConsumer: boolean,
    attachmentOriginalUrl: string,
    permissionLevel: AttachmentPermissionLevel,
    previewContext: PreviewContext
): IContextualMenuItem {
    const attachmentModel = getAttachment(attachment.attachmentId);
    const fileType = getAttachmentFileType(attachmentModel);

    if (
        !isMenuActionSupported(AttachmentMenuAction.Preview, attachment) ||
        getAttachmentDefaultOpenAction(attachment.strategy) !== AttachmentOpenAction.Preview ||
        !attachmentModel ||
        isSxSDisplayedForAttachment(attachment.attachmentId, sxsId)
    ) {
        return null;
    }

    return {
        name: loc(PreviewText),
        key: 'Preview',
        iconProps:
            isFeatureEnabled('wvn-chicletEditOptions') ||
            isFeatureEnabled('wvn-chicletEditOptionsNoDownload')
                ? { iconName: ControlIcons.DocumentSearch }
                : undefined,
        onClick: () => {
            logUsage('AttachmentContextMenuItemPreview', [
                attachment.isCloudy,
                attachmentModel.attachmentClass,
                fileType,
                attachmentModel.model.AttachmentId?.Id,
            ]);
            lazyPreviewAttachment.importAndExecute(previewContext);
        },
    };
}
